// extracted by mini-css-extract-plugin
export default {"btn":"MyButton_btn__3nhU2","disabled":"MyButton_disabled__9tfkn"};